import { createCrudActions } from '../utils/crudGenerator';
import { axios } from '../connection/ConnectionHandler';
import { ADD_NEW_QUESTION } from '../constants';

const formatQuestions = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        kind: item.kind || "incidence",
        label: item.text || item.name || "",
        value: item._id,
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchQuestions,
    create: createQuestion,
    update: updateQuestion,
    delete: deleteQuestions
} = createCrudActions('QUESTION', "Pregunta", formatQuestions);

/** Crea una pregunta y devuelve el documento creado (con _id). Para importación. */
export const createQuestionAndGet = (body) => async (dispatch) => {
    const response = await axios.post("question", body);
    const formatted = formatQuestions(response.data);
    dispatch({ type: ADD_NEW_QUESTION, payload: formatted });
    return formatted;
};